var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-badge"},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.text))])]},{"value":_vm.value,"text":_vm.text})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }